import React, {createContext, useContext, useMemo, useRef, useState} from "react";
import PropTypes from "prop-types";
import {getUserTypeFromLocalToken, userType} from "../../../auth/accessTokenValidator";

const NO_OP_TIMER = {startLoad: () => {}, finishLoad: () => {}, cancelLoad: () => {}};

const ProjectionLoadTimerContext = createContext(NO_OP_TIMER);

export const useProjectionLoadTimer = () => useContext(ProjectionLoadTimerContext);

export const ProjectionLoadTimer = ({children}) => {
    const [completedLoad, setCompletedLoad] = useState(null);
    const startedLoad = useRef(null);
    const isAdminUser = getUserTypeFromLocalToken() === userType.adminUser;

    const timer = useMemo(() => ({
        startLoad: (source) => {
            startedLoad.current = {source, startTime: performance.now()};
            setCompletedLoad(null);
        },
        finishLoad: (itemCount) => {
            if (!startedLoad.current) return;
            const {source, startTime} = startedLoad.current;
            startedLoad.current = null;
            setCompletedLoad({source, itemCount, durationMs: performance.now() - startTime});
        },
        cancelLoad: () => {
            startedLoad.current = null;
        },
    }), []);

    return (
        <ProjectionLoadTimerContext.Provider value={timer}>
            {isAdminUser && completedLoad &&
                <div className={'projection-load-duration'} data-testid={'projection-load-duration'}>
                    Loaded {completedLoad.source} in {(completedLoad.durationMs / 1000).toFixed(2)}s
                    {Number.isFinite(completedLoad.itemCount) && ` Total Stores (${completedLoad.itemCount})`}
                </div>}
            {children}
        </ProjectionLoadTimerContext.Provider>
    );
};

ProjectionLoadTimer.propTypes = {
    children: PropTypes.any,
};

export default ProjectionLoadTimer;
